export interface CategoryItem {
  id: string;
  name: string;
  url: string;
  description: string;
  icon: string;
  imageUrl: string;
}

export const categories: CategoryItem[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Curated sneaker and footwear spreadsheet links from top sellers',
    icon: 'ri-footprint-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20trendy%20sneakers%20displayed%20on%20a%20wooden%20shelf%20against%20a%20bright%20white%20wall%2C%20sunlight%20streaming%20from%20the%20left%2C%20minimalist%20product%20display%2C%20clean%20editorial%20style%2C%20earthy%20color%20palette%20of%20tan%20white%20and%20olive%2C%20no%20people&width=600&height=450&seq=cat-img-shoes-2026&orientation=landscape',
  },
  {
    id: 'hoodies-sweaters',
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    description: 'Premium hoodies and sweater finds for every season',
    icon: 'ri-t-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20folded%20beige%20oversized%20hoodie%20placed%20on%20a%20concrete%20surface%20next%20to%20a%20small%20potted%20plant%2C%20soft%20morning%20light%20from%20a%20nearby%20window%2C%20cozy%20minimalist%20aesthetic%2C%20Scandinavian%20interior%20style%2C%20cream%20and%20soft%20gray%20tones&width=600&height=450&seq=cat-img-hoodies-2026&orientation=landscape',
  },
  {
    id: 't-shirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    description: 'Essential tee collections from verified spreadsheet sources',
    icon: 'ri-t-shirt-air-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20white%20cotton%20t-shirts%20hanging%20on%20a%20wooden%20clothes%20rack%20in%20a%20bright%20airy%20room%2C%20natural%20daylight%20illuminating%20the%20fabric%20texture%2C%20minimalist%20home%20setting%2C%20clean%20lifestyle%20photography%2C%20white%20walls%20and%20light%20wood%20floors&width=600&height=450&seq=cat-img-tshirts-2026&orientation=landscape',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    description: 'Statement jackets and outerwear from curated spreadsheets',
    icon: 'ri-t-shirt-air-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20olive%20green%20bomber%20jacket%20draped%20over%20a%20minimalist%20chair%20in%20a%20bright%20studio%2C%20side%20lighting%20creating%20soft%20shadows%20on%20a%20white%20wall%2C%20editorial%20fashion%20photography%2C%20clean%20composition%2C%20warm%20earthy%20tones&width=600&height=450&seq=cat-img-jackets-2026&orientation=landscape',
  },
  {
    id: 'pants-shorts',
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    description: 'Bottom wear essentials sourced from top spreadsheet links',
    icon: 'ri-handbag-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20tailored%20beige%20trousers%20neatly%20folded%20on%20a%20white%20marble%20surface%2C%20with%20a%20leather%20belt%20placed%20beside%20them%2C%20soft%20overhead%20studio%20lighting%2C%20luxury%20minimalist%20product%20photography%2C%20neutral%20color%20palette&width=600&height=450&seq=cat-img-pants-2026&orientation=landscape',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    description: 'Caps, beanies and headwear from trusted spreadsheet collections',
    icon: 'ri-customer-service-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20baseball%20caps%20in%20black%20navy%20and%20cream%20arranged%20on%20a%20rustic%20wooden%20table%2C%20warm%20afternoon%20sunlight%20casting%20long%20shadows%2C%20lifestyle%20flat%20lay%20photography%2C%20casual%20streetwear%20aesthetic%2C%20natural%20textures&width=600&height=450&seq=cat-img-headwear-2026&orientation=landscape',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    description: 'Complete outfit sets and coordinated collections',
    icon: 'ri-stack-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20tracksuit%20set%20in%20soft%20gray%20displayed%20on%20a%20minimalist%20mannequin%20against%20a%20light%20beige%20backdrop%2C%20professional%20fashion%20photography%2C%20clean%20studio%20lighting%2C%20modern%20athleisure%20style&width=600&height=450&seq=cat-img-sets-2026&orientation=landscape',
  },
  {
    id: 'underwear',
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    description: 'Essential undergarments from reliable spreadsheet sources',
    icon: 'ri-box-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20basics%20neatly%20arranged%20in%20a%20drawer%20with%20natural%20light%20coming%20from%20above%2C%20clean%20minimalist%20organization%20photography%2C%20white%20and%20pastel%20tones%2C%20cozy%20home%20aesthetic%2C%20texture%20focused&width=600&height=450&seq=cat-img-underwear-2026&orientation=landscape',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    description: 'Sports jerseys and athletic wear spreadsheet finds',
    icon: 'ri-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vibrant%20soccer%20jersey%20hung%20on%20a%20minimalist%20clothes%20hanger%20against%20a%20dark%20charcoal%20wall%2C%20dramatic%20top-down%20spotlight%2C%20sport%20editorial%20photography%2C%20bold%20contrast%2C%20professional%20stadium%20lighting%20effect&width=600&height=450&seq=cat-img-jersey-2026&orientation=landscape',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    description: 'Watches, jewelry and style accessories from curated links',
    icon: 'ri-vip-diamond-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20wristwatch%20and%20a%20silver%20bracelet%20placed%20on%20a%20white%20ceramic%20tray%2C%20soft%20window%20light%20reflecting%20off%20the%20metal%2C%20luxury%20minimalist%20product%20photography%2C%20clean%20elegant%20composition%2C%20cream%20and%20silver%20tones&width=600&height=450&seq=cat-img-accessories-2026&orientation=landscape',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    description: 'Backpacks, totes and bag collections from spreadsheet finds',
    icon: 'ri-shopping-bag-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20leather%20backpack%20resting%20on%20a%20wooden%20bench%20in%20a%20sunlit%20cafe%20corner%2C%20warm%20natural%20light%20streaming%20through%20large%20windows%2C%20lifestyle%20product%20photography%2C%20cozy%20urban%20aesthetic%2C%20brown%20and%20cream%20tones&width=600&height=450&seq=cat-img-bags-2026&orientation=landscape',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    description: 'Designer-inspired belts and accessories spreadsheet links',
    icon: 'ri-link',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20rolled%20brown%20leather%20belt%20with%20a%20gold%20buckle%20placed%20on%20a%20white%20linen%20cloth%2C%20side%20natural%20light%20highlighting%20the%20leather%20grain%2C%20luxury%20product%20photography%2C%20minimalist%20elegant%20composition%2C%20warm%20neutral%20palette&width=600&height=450&seq=cat-img-belts-2026&orientation=landscape',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    description: 'Fragrance and perfume spreadsheet collection links',
    icon: 'ri-contrast-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20glass%20perfume%20bottle%20with%20amber%20liquid%20placed%20on%20a%20dark%20wooden%20surface%2C%20candlelight%20creating%20warm%20reflections%20on%20the%20glass%2C%20atmospheric%20luxury%20product%20photography%2C%20intimate%20moody%20lighting%2C%20rich%20golden%20and%20brown%20tones&width=600&height=450&seq=cat-img-perfumes-2026&orientation=landscape',
  },
  {
    id: 'other-stuff',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    description: 'Miscellaneous finds, gadgets and unique spreadsheet items',
    icon: 'ri-more-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20assortment%20of%20lifestyle%20accessories%20including%20a%20notebook%2C%20keychain%2C%20and%20sunglasses%20arranged%20on%20a%20white%20desk%2C%20soft%20overhead%20lighting%2C%20minimalist%20desk%20photography%2C%20clean%20modern%20aesthetic%2C%20mixed%20textures%20and%20neutral%20colors&width=600&height=450&seq=cat-img-other-2026&orientation=landscape',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com/';

export const externalLinkAttrs = {
  target: '_blank',
  rel: 'noopener nofollow',
};